import { createAction } from '@reduxjs/toolkit';
import { type MapPresentationalView } from './mapPresentational.state';

export const mapPresentationalSetView = createAction('MAP_PRESENTATIONAL/SET_VIEW',
  (view: MapPresentationalView) => ({ payload: { view } }));

export const mapPresentationalSetShowWrongPasswordError = createAction('MAP_PRESENTATIONAL/SET_SHOW_WRONG_PASSWORD_ERROR',
  (showPasswordError: boolean) => ({ payload: { showPasswordError } }));

export const mapPresentationalSetShowPresentationalMenu = createAction('MAP_PRESENTATIONAL/SET_SHOW_PRESENTATIONAL_MENU',
  (isMenuOpen: boolean) => ({ payload: { isMenuOpen } }));

export const mapPresentationalMapAccessTokenReceived = createAction('MAP_PRESENTATIONAL/ACCESS_TOKEN_RECEIVED',
  (mapAccessToken: string | null) => ({ payload: { mapAccessToken } }));
